import Moment from 'moment';

export const daysToDaysWeeks = (days) => {
    if (days === undefined || days === null) {
        return null;
    }

    if (days === 0) {
        return "0d";
    }

    var weeks = parseInt(days / 7);

    if (weeks > 0) {
        return weeks + "w " + Math.round(days % 7, 1) + "d";
    }
    else {
        return days + "d";
    }

}

export const createdFromNow = (createdDate) => {
    const currentUtcDate = Moment.utc();
    return Moment.utc(createdDate).from(currentUtcDate);
}

export const getRandomHourOfDay = () => {
    const min = Math.ceil(1);
    const max = Math.floor(24);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const getRandomDayOfWeek = () => {
    const min = Math.ceil(1);
    const max = Math.floor(7);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
